import React, { useMemo } from 'react'

import dayjs from 'dayjs'
import parsePhoneNumberFromString from 'libphonenumber-js'

import { FieldValidation } from './FieldValidation'

export const isValidEmail = (value: string) => {
  const v = value.trim()
  if (!v) return true // vacío => no muestro error
  const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
  return regex.test(v)
}

export const areEquals = (originalValue: string) => {
  return (confirmationValue: string) => {
    const v = confirmationValue.trim()
    if (!v) return true // vacío => no muestro error
    const original = originalValue.trim()
    if (!original) return true // si el original está vacío, no validar
    return original === v // retorna true si son iguales (válido)
  }
}

export const isValidPassword = (value: string) => {
  const v = value.trim()
  if (!v) return true // vacío => no muestro error
  const hasMinLength = value.length >= 8
  const hasUppercase = /[A-Z]/.test(value)
  const hasLowercase = /[a-z]/.test(value)
  const hasNumber = /[0-9]/.test(value)
  const hasSymbol = /[@$!%*?&]/.test(value)

  // TODO: ver como pasar el mensaje para el error
  // let errorMessage = ''

  // if (
  //   !hasMinLength ||
  //   !hasUppercase ||
  //   !hasLowercase ||
  //   !hasNumber ||
  //   !hasSymbol
  // ) {
  //   errorMessage += '<p>La contraseña debe:</p> '
  //   if (!hasMinLength) {
  //     errorMessage += '<p>Tener al menos 8 caracteres</p> '
  //   }
  //   if (!hasUppercase) {
  //     errorMessage += '<p>Tener al menos una mayúscula</p>'
  //   }
  //   if (!hasLowercase) {
  //     errorMessage += '<p>Tener al menos una minúscula</p>'
  //   }
  //   if (!hasNumber) {
  //     errorMessage += '<p>Tener al menos un número</p>'
  //   }
  //   if (!hasSymbol) {
  //     errorMessage += '<p>Tener al menos un símbolo</p>'
  //   }
  // }

  return hasMinLength || hasUppercase || hasLowercase || hasNumber || hasSymbol
}

export const isValidPhone = (value: string) => {
  const v = value.trim()
  if (!v) return true // vacío => no muestro error
  const phoneObj = parsePhoneNumberFromString(v)
  return !!phoneObj?.isValid()
}

export const valueIsNumber = (value: unknown): value is number => {
  return typeof value === 'number' && !isNaN(value) && isFinite(value)
}

export const isValidDate = (value: string) => {
  const v = value.trim()
  if (!v) return true // vacío => no muestro error

  // Intentar parsear la fecha en diferentes formatos comunes
  const formats = [
    // 'DD-MM-YYYY',
    'DD/MM/YYYY',
    // 'YYYY-MM-DD',
    // 'YYYY/MM/DD',
    // 'MM-DD-YYYY',
    // 'MM/DD/YYYY',
  ]

  for (const format of formats) {
    const parsed = dayjs(v, format, true) // strict mode
    if (parsed.isValid()) {
      return true
    }
  }

  // Si ningún formato funciona, intentar parseo automático
  const autoParsed = dayjs(v)
  return autoParsed.isValid()
}

const Validations = ({
  value,
  validation,
  minLengthToValidate = 1,
  showMandatory = false,
}: {
  value: string
  validation?: {
    validate: (value: string) => boolean
    message: string
  }
  minLengthToValidate?: number
  showMandatory?: boolean
}) => {
  const v = String(value ?? '').trim()

  const showError = useMemo(() => {
    if (v.length < minLengthToValidate) return false
    return validation?.validate && !validation?.validate(v)
  }, [v, minLengthToValidate, validation?.validate])

  return (
    <FieldValidation
      showError={showError}
      message={validation?.message}
      showMandatoryError={showMandatory}
    />
  )
}

export default Validations
